/**
 * Windermere2 Theme Configuration - Enhanced Design
 *
 * An elevated, premium design for Windermere Preparatory School
 * featuring refined typography, subtle animations, and a sophisticated
 * color palette that reflects Nord Anglia's global education brand.
 */

export const windermere2Theme = {
  name: 'windermere2',
  brandName: 'Windermere Preparatory School',
  logoPath: 'nord-anglia-school_windermere_logo_horizontal_white.png',

  colors: {
    // Primary palette - sophisticated navy with warm accents
    headerColor: '#0a1628',            // Deeper, richer navy
    headerHover: '#06101c',            // Even darker navy for hover
    frameColor: '#132238',             // Dark navy with subtle warmth
    buttonColor: '#00b4a6',            // Refined teal - more vibrant
    buttonHover: '#009187',            // Darker teal for hover
    highlightButtonColor: '#ff6b35',   // Warm coral accent for CTAs
    highlightButtonHover: '#e55a27',   // Darker coral for hover
    headerButtonColor: '#00d4c4',      // Bright teal for header actions
    textColor: '#1a2332',              // Rich dark text
    lightTextColor: '#ffffff',         // Pure white
    buttonTextColor: '#0a1628',        // Dark text on light buttons
    headerTextColor: '#f0f4f8',        // Soft white for headers
    headerButtonTextColor: '#0a1628',  // Dark text on teal buttons
    alertColor: '#ef4444',             // Modern red
    alertHover: '#dc2626',             // Darker red for hover
    successColor: '#10b981',           // Emerald green
    successHover: '#059669',           // Darker emerald for hover
    inactiveColor: '#94a3b8'           // Slate gray
  },

  components: {
    header: 'WindermereHeader2',       // Enhanced header component
    hero: 'WindermereHero2',           // Enhanced hero component
    footer: 'GenericFooter'
  },

  features: {
    megaMenu: true,
    searchBar: true,
    scrollEffects: true,
    heroSection: true
  },

  contact: {
    phone: '(407) 905-7737',
    email: 'admissions@windermereprep.com',
    address: '6189 Winter Garden-Vineland Road, Windermere, FL 34786'
  },

  branding: {
    tagline: 'Be Ambitious',
    heroTitle: 'Welcome to Windermere Preparatory School',
    heroDescription: 'A Nord Anglia Education School - Discover our premium collection of school uniforms, supplies, and spirit wear.',
    heroImage: 'windermere-hero-bg.jpg'
  }
}
